/*
 * @Descripttion:
 * @version:
 * @Author: sujun
 * @email: 1373842098@qq.com
 * @Date: 2021-12-31 11:05:42
 * @LastEditors: K
 * @LastEditTime: 2022-09-21 11:01:24
 */
import { TableColumnType } from 'antd'
import { ReactElement } from 'react'
import React from 'react'
import { getSexName } from '../../../../models/StatisticAnalysis'
import { getTenantCategoryName, Tenant } from '../../../../models/tenant'

export const Columns = (startIndex: number): TableColumnType<any>[] => {
  return [
    {
      title: '订单编号',
      key: 'id',
      align: 'center',
      dataIndex: 'id'
    },
    {
      title: '代煎饮片厂',
      key: 'supplierName',
      align: 'center',
      // dataIndex: 'supplierName'
      render: (_, t) => t.supplierName || '-'
    },
    {
      title: '机构名称',
      key: 'hospitalName',
      align: 'center',
      dataIndex: 'hospitalName'
    },
    {
      title: '签约状态',
      key: 'signedType',
      align: 'center',
      dataIndex: 'signedType',
      render: (_, t) => (t.signedType === 1 ? '已签约' : '未签约'),
    },
    {
      title: '处方金额',
      key: 'money',
      align: 'center',
      width: '12rem',
      render: (_, t) => t.money,
    },
    {
      title: '药方金额',
      key: 'decoctMoney',
      align: 'center',
      width: '12rem',
      render: (_, t) => (t.money - t.decoctMoney).toFixed(2),
    },
    {
      title: '上传状态',
      key: 'status',
      align: 'center',
      width: '12rem',
      render: (_, t) => {
        if (t.status === 0) {
          return (<span style={{ color: '#FCCC6D' }}>未上传 </span>)
        } else if (t.status === 1) {
          return '已上传'
        } else {
          return '-'
        }
      }
    },
    {
      title: '开单时间',
      key: 'createTime',
      align: 'center',
      width: '12rem',
      dataIndex: 'createTime'
      // render: (_, t) => t.createTime?.split(' ')?.[0],
    },
    {
      title: '上传时间',
      key: 'uploadTime',
      align: 'center',
      width: '12rem',
      dataIndex: 'uploadTime'
      // render: (_, t) => t.createTime?.split(' ')?.[0],
    },
    {
      title: '患者姓名',
      key: 'age',
      align: 'center',
      dataIndex: 'recipientName'
    },
    {
      title: '患者性别',
      key: 'sexType',
      align: 'center',
      render: (_, t) => (
        getSexName(t.sexType)
      )
    },
    {
      title: '年龄',
      key: 'age',
      align: 'center',
      dataIndex: 'age'
    },

    // {
    //   title: '操作',
    //   key: 'action',
    //   align: 'center',
    //   width: '10em',
    //   render: function ActionBar(_, t): ReactElement {
    //     return <a onClick={() => onClick('partner', t)}>查看合作机构 </a>
    //   },
    // },
  ]
}
